import { combineReducers } from 'redux';
import authenticationReducer from '../../containers/Authentication/Authentication.reducer';
import maintenanceReducer from '../../containers/Maintenance/Ongoing/Ongoing.reducer';
import databaseReducer from '../../containers/Database/Initial/Database.reducer';
import navbarReducer from '../../containers/Navbar/Navbar.reducer';
import kpiTreeReducer from '../../containers/Productivity/KpiTree/KpiTree.reducer';
import notificationReducer from '../../containers/Notifications/Notifications.reducer';
import keplerGlReducer from '@kepler.gl/reducers';
import { LOCALE_CODES } from '@kepler.gl/localization';
import mapboxReducer from '../../containers/Kepler/Kepler.reducer';
import cyclesReducer from '../../containers/Cycles/Cycles/Cycles.reducer';
import timesReducer from '../../containers/Times/Times.reducer';

const customizedKeplerGlReducer = keplerGlReducer.initialState({
  uiState: {
    // use Spanish locale
    locale: LOCALE_CODES.en,
    mapControls: {
      mapLegend: {
        show: true,
        active: true,
      },
    },
  },
});
export default combineReducers({
  keplerGl: customizedKeplerGlReducer,
  auth: authenticationReducer,
  maintenance: maintenanceReducer,
  database: databaseReducer,
  navbar: navbarReducer,
  kpiTree: kpiTreeReducer,
  notification: notificationReducer,
  mapbox: mapboxReducer,
  cycles: cyclesReducer,
  times: timesReducer,
});
